<div class="otp-dialog">

    <!-- Shared shield header (subtitle tracks the current screen) -->
    <div class="dialog-header">
        <div class="shield-icon">
            <i class="ph-bold ph-shield-check" aria-hidden="true"></i>
        </div>
        <div class="dialog-title">Additional Verification Required</div>
        <div class="dialog-subtitle">{{ subtitle }}</div>
    </div>

    <!-- Type selection screen -->
    <ng-container *ngIf="!type">
        <div class="dialog-body">
            <div class="type-buttons">
                <button type="button" data-testid="confirm-2fa-method-sms" [disabled]="isSendingSms" (click)="setSmsType()">
                    <i class="ph-bold ph-chat-circle-text" aria-hidden="true"></i>
                    <span>
                        <strong>{{ isSendingSms ? 'Sending code...' : 'Text me a code' }}</strong>
                        <small>Receive a code via SMS</small>
                    </span>
                </button>
                <button type="button" data-testid="confirm-2fa-method-google" [disabled]="isSendingSms" (click)="setGoogleType()">
                    <i class="ph-bold ph-lock-key" aria-hidden="true"></i>
                    <span>
                        <strong>Authenticator app</strong>
                        <small>Use your authenticator app</small>
                    </span>
                </button>
            </div>
        </div>

        <div class="dialog-footer dialog-footer--single">
            <button type="button" class="btn-cancel" mat-dialog-close>Cancel</button>
        </div>
    </ng-container>

    <!-- OTP entry screen -->
    <ng-container *ngIf="type">
        <div class="dialog-body">
            <!-- OTP cells (shared control) -->
            <app-otp-code-input
                    [disabled]="isSubmitting || isSuccess"
                    [error]="hasError"
                    [success]="isSuccess"
                    (valueChange)="onCodeChange($event)"
                    (completed)="submit($event)"></app-otp-code-input>

            <div class="otp-hint" [class.otp-hint-error]="hasError" [class.otp-hint-success]="isSuccess">{{ hintText }}</div>

            <!-- Trust-device -->
            <ng-container *ngIf="showTrustDevice">
                <mat-divider></mat-divider>
                <mat-checkbox data-testid="confirm-2fa-trust-device" [(ngModel)]="trustDevice" [disableRipple]="true">Trust this browser</mat-checkbox>
                <p>Don't ask for a code again on this browser for 30 days. Only use on personal devices.</p>
            </ng-container>
        </div>

        <div class="dialog-footer">
            <button type="button" class="btn-cancel" *ngIf="canGoBack" (click)="goBack()">Back</button>
            <button type="button" class="btn-cancel" *ngIf="!canGoBack" mat-dialog-close>Cancel</button>
            <flex-spacer></flex-spacer>
            <button type="button"
                    class="btn-verify"
                    data-testid="confirm-2fa-submit"
                    [class.btn-verify--success]="isSuccess"
                    [disabled]="code.length < 6 || isSubmitting || isSuccess"
                    (click)="submit(code)">
                <mat-spinner *ngIf="isSubmitting && !isSuccess" class="btn-verify__spinner" diameter="16"></mat-spinner>
                <span *ngIf="!isSubmitting && !isSuccess">Verify</span>
                <span *ngIf="isSubmitting && !isSuccess">Verifying…</span>
                <span *ngIf="isSuccess">Verified</span>
            </button>
        </div>
    </ng-container>

</div>
